module.exports = __webpack_public_path__ + "static/media/Rita Skeeter 1.7ecbf304.jpg";